export enum StatusEmployer {
    Enabled = 'Activado',
    Disabled = 'Desactivado',
    Default = Disabled
}
 
export enum StatusApplication {
    Sent = 1,
    Discard = 2,
    Selected = 3,
    ForInterviewing = 4,
    Hired = 5
}

export enum EmployeeMethodAPI {
    getEmployeeLead = 'thtnIvipOOdxajdTKUhZ/',
}

export enum EmployerMethodAPI {
    insertEmployerBasic = 'VGroAmpiUKGubIwXgvuV/',
    updateEmployerBasic = 'SYaDlxViHlGMcmqczFey/',
}
